import { Controller } from "@hotwired/stimulus"

// qualifications.html.erb の「資格なし」「その他の資格」 shortcut button 用 controller (#1833 PR 8b)。
//
// shortcut button が form の外側 (`content_for :below_card`) に位置するため form scope に
// controller を載せられない構造。
//
// 解決: shortcut button group の wrapper div に controller を attach、form は `formIdValue` で
// id 経由 lookup する contract で接続。partial の `submit_data:` と同様の **構造的契約 pattern**
// (memory `reference_stimulus_migration_benefits` の Partial 構造的契約 section 参照)。
//
// 役割:
// 1. shortcut button (`資格なし` / `その他の資格`) click → 関連 checkbox を clear + 指定値の
//    hidden input を append + form submit
// 2. 関連 form の checkbox state 変化を `change` event delegation で監視、any-checked 時に
//    shortcut button を disable (mutual exclusion: 資格 検索 と 「資格なし」 「その他」 は排他)
//
// scope: shortcut button group の wrapper div に置く。
//
// XSS 安全性: input.value に user 入力は介在せず view literal (`資格なし` / `その他の資格`)
// のみ、textContent / classList のみで innerHTML 不使用。
//
// Rule of Three: 1 view 1 instance (qualifications 専用)、`formId` / `fieldName` value で
// 形だけ generic にしているが他 step に展開予定なし。class 名 / submit value は hardcoded。
export default class extends Controller {
  static targets = ["button"]
  static values = { formId: String, fieldName: String }

  connect() {
    this.form = document.getElementById(this.formIdValue)
    if (!this.form) return

    this.handleFormChange = this.handleFormChange.bind(this)
    this.form.addEventListener("change", this.handleFormChange)
    this.handleFormChange()
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener("change", this.handleFormChange)
      this.form = null
    }
  }

  // form 内の対象 checkbox 群を監視、any-checked 時に shortcut button を disable。
  handleFormChange() {
    const checkboxes = this.form.querySelectorAll(`input[name="${this.fieldNameValue}"]`)
    const anyChecked = Array.from(checkboxes).some((cb) => cb.checked)
    this.buttonTargets.forEach((btn) => {
      btn.disabled = anyChecked
    })
  }

  // shortcut button click: form の対象 checkbox を全 clear → button data-submit-value を
  // hidden input として append → form submit。旧 inline JS の `submitWithValue(value)` parity。
  submitWith(event) {
    if (!this.form) return
    const value = event.currentTarget.dataset.submitValue
    if (!value) return

    // 既存 checkbox を全 clear (排他のため hidden input のみが送信されるよう保証)
    this.form.querySelectorAll(`input[name="${this.fieldNameValue}"]`).forEach((cb) => {
      cb.checked = false
    })

    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = this.fieldNameValue
    hidden.value = value
    this.form.appendChild(hidden)

    this.form.submit()
  }
}
